import type { ReactNode } from "react";
import Breadcrumb from "../../shared/Breadcrumb";
import Lazy from "../../shared/Lazy";
import { Mutation } from "../../api/Mutation";
import Export from "./Export";

export const PATH = "/admin/tools";
export const TITLE = "Admin\u00a0Tools";

function Tool({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section>
      <h2>{title}</h2>
      <Lazy label="Show">{children}</Lazy>
    </section>
  );
}

export function AdminToolsPage() {
  const path = [{ path: PATH, label: TITLE }];
  return (
    <article>
      <Breadcrumb path={path} />
      <h1>{TITLE}</h1>

      <Tool title="Export Report Data">
        <Export />
      </Tool>
      <Tool title="Run Archive Reports">
        <Mutation
          method="POST"
          path="admin/reports/archive/run"
          title="Archive Reports"
        />
      </Tool>
      <Tool title="Send Archive Notifications">
        <Mutation
          method="POST"
          path="admin/reports/archive/notifications"
          title="Send Archive Notifications"
        />
      </Tool>
    </article>
  );
}
